export const EXTERNAL_ID_TYPE = 'alpha';
export const BODY_RETAIL = 'yes';
